<template>
  <div>
    <el-dialog :title="zhuangXianSettingData.title" :visible.sync="zhuangXianSettingData.show" width="800px" center>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    zhuangXianSettingData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>